function getEnvVar(name: string): string {
  const value = import.meta.env[name];
  if (!value) {
    throw new Error(`Missing environment variable`);
  }
  return value;
}

export const apiUrl = getEnvVar("VITE_API_URL");
export const moodleLmsLink = getEnvVar("VITE_MOODLE_LMS_LINK");
export const awsBucketName = getEnvVar("VITE_AWS_BUCKET_NAME");
export const awsRegion = getEnvVar("VITE_AWS_REGION");

// export const cloudName = getEnvVar("VITE_CLOUDINARY_CLOUD_NAME");
// export const cloudinaryPreset = getEnvVar("VITE_CLOUDINARY_UNSIGNED_PRESET");
